import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../api';
import './GemCard.css';

export default function GemCard({ gem }) {
  const navigate = useNavigate();

  return (
    <div className="gem-card">
      <div className="gem-card-img">
        <img src={getImageUrl(gem.image)} alt={gem.name} />
      </div>
      <div className="gem-card-info">
        <p className="gem-card-name">{gem.name}</p>
        <p className="gem-card-price">Rs.{gem.price?.toLocaleString()}</p>
      </div>
      <button className="gem-card-btn" onClick={() => navigate(`/gem/${gem._id}`)}>
        SHOP NOW
      </button>
    </div>
  );
}
